import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import MyLink from "../../components/myLink";
import Note from "../../components/note";
import Caution from "../../components/caution";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <li>
      <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
        1.0 Routine Patient Care
      </MyLink>
    </li>
    <li>
      Manage hypoglycemia and narcotic overdose per protocol.
    </li>
    <li>
      Consider eclampsia in a woman of childbearing age
    </li>
        <br />

        <strong> CAUTION: </strong> Do NOT administer anything orally if the
patient does not have a reasonable level of consciousness and normal
gag reflex.
  </ul>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  <ul>
    <li>
      If Diazepam rectal gel (Diastat) has been prescribed by the patient’s
      physician, assist the caregiver with administration in accordance with
      physician’s instructions.
    </li>
    <li>
      If the patient has an implanted vagus nerve stimulator (VNS), suggest that
      the family use the VNS magnet to activate the VNS and assist if required.
    </li>
    <ul>
      <li>
        To use the VNS magnet, pass the magnet closely over the VNS
        device; if unsuccessful, repeat every 3-5 minutes for a total of 3 times.
      </li>
      <br />
      Note: Do not delay medication administration.
    </ul>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <ul>
    <li>
      Cardiac Monitor and if feasible 12 lead ECG – Manage dysrhythmias per
      protocol.
    </li>
    <li>
      If patient is in Status Epilepticus
    </li>
    <ul>
      <li>
        Midazolam 2 - 6 mg slow IV/IO/IM
      </li>
      OR
      <li>
        Midazolam 10 mg IN
      </li>
      <li>
        Magnesium sulfate 2-4 grams IV/IO over 5 minutes if suspect eclampsia
      </li>
    </ul>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" medControl={true} mdxType="EMTLevel">
  Additional doses of above medications.
    </EMTLevel>
    <Caution id="caution-1" mdxType="Caution">
  Benzodiazepines may be contraindicated in head injury or hypotension;
  discuss with medical control.
    </Caution>
    <Note id="note-1" alignment="left" mdxType="Note">
  <ul>
    <li>
      Post-partum patients may experience eclamptic seizures up to several
      weeks after giving birth.
    </li>
    <li>
      Status epilepticus is defined as any generalized seizures lasting
      more than 5 minutes.  This is a true emergency requiring rapid airway
      control, treatment (including benzodiazepines), and transport.
    </li>
  </ul>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      